import { APIClient } from "./api_helper";

import * as url from "./realtime_url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

export const getCategories = (id: any) => api.get(url.GET_CATEGORY, { id: id });
export const getCategoriesSelect = (categoryId: string) =>
  api.get(url.GET_CATEGORY_SELECT, { categoryId: categoryId });
export const searchCategories = (keyword: string) =>
  api.get(url.GET_CATEGORY_SEARCH, { keyword: keyword.toLowerCase() });
export const searchAllBrands = (keyword: string) =>
  api.get(url.GET_BRAND_SEARCH, { keyword: keyword.toLowerCase() });
export const createProducts = (data: any) =>
  api.create(url.POST_PRODUCTS, { ...data });
export const createDraftProducts = (data: any) =>
  api.create(url.POST_DRAFT, { ...data });
export const updateProducts = (id: string, data: any) =>
  api.put(url.UPDATE_PRODUCTS + id, { ...data });
export const updateDraftProducts = (id: string, data: any) =>
  api.put(url.UPDATE_DRAFTS + id, { ...data });
export const postSignUp = (data: any) => api.create(url.SIGNUP, data);
export const productUpdate = (data: any) =>
  api.put(url.UPDATE_PRODUCT, { ...data });
  export const MainProductUpdate = (data: any) =>
  api.put(url.UPDATE_PRODUCT_MAIN, { ...data });
export const postRefreshAuth = () => api.create(url.REFRESH, {});
export const createBusiness = (data: any) =>
  api.create(url.CREATE_BUSINESS, data);
export const validateStoreName = (storeName: string) =>
  api.get(url.VALIDATE_STORE_NAME, { storeName });
export const authMe = () => api.get(url.ME, "");
export const getProducts = (
  page: any,
  count: any,
  status: any,
  keyword: string,
  keywordType?: any,
  categoryId?: any
) =>
  api.get(url.GET_PRODUCTS, {
    page: page,
    count: count,
    status: status,
    keyword,
    keywordType,
    categoryId,
  });

  export const getOrderCsv = (
  startDate : string,
  endDate : string,
  count : any,
  status: string,
  isQuickCommerce:boolean
) =>
  api.get(url.GET_ORDERS_CSV, {
    startDate : startDate ,
    endDate : endDate ,
    count : count ,
    status: status,
    isQuickCommerce:isQuickCommerce
  });

export const getProductsByCampaign = (
  page: any,
  count: any,
  status: any,
  keyword: string,
  keywordType?: any,
  categoryId?: any
) =>
  api.get(url.GET_PRODUCTS_CAMPAIGN, {
    page: page,
    count: count,
    status: status,
    keyword,
    keywordType,
    categoryId,
  });
export const getDraftProducts = (
  page: any,
  count: any,
  status: any,
  keyword: string
) =>
  api.get(url.GET_DRAFT_PRODUCTS, {
    page: page,
    count: count,
    status: status,
    keyword,
  });

  export const getLoadCsv = (
    type:any,
  fromdate: string,
  todate : string,
) =>
  api.get(url.GET_LOAD_SHEET, {
    type : type ,
    fromdate : fromdate ,
    todate : todate ,
  });
export const getBrandsByKeyword = (page: any, count: any, keyword: string) =>
  api.get(url.GET_BRAND_BY_KEYWORD, { page: page, count: count, keyword });

export const getSellerPerformance = ( startDate:string, endDate:string, keywordType:string, page: any, count: any, keyword: string, categoryId:string, brandId: string,sortTypeProduct:number,sortTypeCart:number,sortTypeSold:number, isProductVisitorFilter:boolean,isProductVisitorFilterCr:boolean, addToCartUnitsFilter:boolean,addToCartUnitsFilterCr:boolean, unitsSoldFilter:boolean , unitsSoldFilterCr:boolean,) =>
  api.get(url.GET_SELLER_PERFORMANCE, { startDate:startDate,endDate:endDate, keywordType:keywordType, page: page, count: count, keyword, categoryId:categoryId , brandId:brandId,sortTypeProduct:sortTypeProduct ,sortTypeCart:sortTypeCart, sortTypeSold:sortTypeSold,isProductVisitorFilter, isProductVisitorFilterCr,addToCartUnitsFilter, addToCartUnitsFilterCr, unitsSoldFilter, unitsSoldFilterCr});

export const getS3Upload = (fileName : any,fileType:any) =>
  api.get(url.GET_S3, { fileName : fileName,fileType:fileType  });


export const getCategoryProductPerformance = (  page: any, count: any, keyword: string, ) =>
  api.get(url.GET_CATEGORY_PRODUCT_PERFORMANCE, {  page: page, count: count, keyword,});

export const getKeyMetrics = (startDate:string, endDate:string,isRevenue:boolean,isVisitor:boolean,isConversionRate:boolean,isRevenuePerBuyer:boolean,isPageView:boolean) =>
  api.get(url.GET_KEY_METRICS, { startDate:startDate,endDate:endDate,isRevenue:isRevenue,isVisitor:isVisitor,isConversionRate:isConversionRate,isRevenuePerBuyer:isRevenuePerBuyer,isPageView:isPageView });

export const getIncomeOverView = (
  page: number,
  count: number,
  starDate:number,
  endDate:number,
  orderId: string,
  status: string,
  keywordType: string,
  keyword: string,
  
) =>
  api.get(url.GET_INCOME_OVERVIEW, {
    page: page,
    count: count,
    starDate:starDate,
    endDate:endDate,
    orderId: orderId,
    status: status,
    keywordType: keywordType,
    keyword: keyword,
  });

// export const getIncomeOverViewDetail = (orderStatementId: string) =>
//   api.get(url.GET_INCOME_OVERVIEW_DETAIL, {
//     orderStatementId: orderStatementId,
//   });

export const getIncomeDetail = (
  page: any,
  count: any,
  starDate: number,
  endDate: number,
  keyword: string,
  status: string,
  keywordType: string,
) =>
  api.get(url.GET_INCOME_Detail, {
    page: page,
    count: count,
    starDate: starDate,
    endDate: endDate,
    keyword: keyword,
    status: status,
    keywordType:keywordType,
  });

export const getChatOrder = (userId: any) =>
  api.get(url.GET_CHAT_ORDERS, { userId });

export const getChatStatus = (ids: any) =>
  api.get(url.GET_CHAT_STATUS, { ids });

export const uploadFile = (formData: FormData) =>
  api.put(url.UPLOAD_VOUCHER, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const getChatVouchers = (userId: any) =>
  api.get(url.GET_CHAT_VOUCHER, { userId });

export const getMarketingInvitation = () =>
  api.get(url.GET_MARKETING_CAMPAIGN_INVITITION, {});

export const getCampaignProducts = (
  page: any,
  count: any,
  campaignId: any,
  keyword: any,
  status?: any,
  categoryId?: any,
  keywordType?: any
) =>
  api.get(url.GET_CAMPAIGN_PRODUCTS, {
    page: page,
    count: count,
    campaignId: campaignId,
    keyword: keyword,
    status: status,
    categoryId: categoryId,
    keywordType: keywordType,
  });

export const createChatRider = (data: any) =>
  api.create(url.GET_CHAT_CREATE, data);

export const createChatAdmin = (data: any) =>
  api.create(url.CREATE_CHAT_FOR_ADMIN, data);

export const getChatProducts = (userId: any) =>
  api.get(url.GET_CHAT_PRODUCTS, { userId });

export const createBrandDetail = (data: any) =>
  api.create(url.CREATE_BRAND_DETAIL, data);
export const postLogin = (data: any) => api.create(url.LOGIN, data);
export const updateBusiness = (data: any) => api.put(url.UPDATE_BUSINESS, data);
export const getOrders = (
  page: any,
  count: any,
  status: any,
  keyword: string
) =>
  api.get(url.GET_ORDERS, {
    page: page,
    count: count,
    status: status,
    keyword,
  });
export const getOrderDetail = (id: any) =>
  api.get(url.GET_ORDERS_DETAIL, { id: id });

export const registerCampaign = (campaignId: any) =>
  api.put(`${url.PUT_REGISTER}?campaignId=${campaignId}`, {});

export const campaignPrice = (
  subProductId: any,
  campaignId: any,
  campainPrice: any
) =>
  api.put(
    `${url.PUT_CAMPAIGN_PRICE}?subProductId=${subProductId}&campaignId=${campaignId}&campainPrice=${campainPrice}`,
    {}
  );

export const campaignAddProduct = (subProductIds: any[], campaignId: any) =>
  api.put(
    `${url.PUT_CAMPAIGN_ADD_PRODUCT}?subProductIds=${subProductIds.join(
      ","
    )}&campaignId=${campaignId}`,
    {}
  );

export const getPrductDraftDetail = (id: any) =>
  api.get(url.GET_PRODUCT_DRAFT_DETAIL + `${id}`, {});
export const deleteDraftProduct = (id: any) =>
  api.delete(url.DELETE_DRAFT_PRODUCT + `${id}`);
export const getProductDetailByUrl = (imageUrl: string) => {
  const encodedUrl = encodeURIComponent(imageUrl);
  return api.get(`api/v1/products/aidata?url=${encodedUrl}`, {});
}
export const putForgetPassword = (data: any) =>
  api.put(url.FORGET_PASSWORD, data);
export const putChangePassword = (data: any) =>
  api.put(url.CHANGE_PASSWORD, data);
// export const getBanks = () => api.get(url.GET_BUSINESS_SELLER_ID, {});
export const getBanks = () => api.get(url.GET_BANKS, {});
export const getState = () => api.get(url.GET_STATE, {});
export const getCityByStateId = (stateId: any) =>
  api.get(url.GET_CITY, { stateId: stateId });
export const getZonesByCityId = (cityId: any) =>
  api.get(url.GET_ZONES, { cityId: cityId });
export const getZonesByNighborhoodId = (zoneid: any) =>
  api.get(url.GET_NEIGHBORHOOD, { zoneid: zoneid });
export const updateOrderStatus = (
  orderId: string,
  status: string,
  reason?: any
) =>
  api.put(url.UPDATE_ORDER_STATUS, {
    orderId: orderId,
    status: status,
    reason: reason,
  });

export const campaignWithdrawn = (
  subProductId: any,
  campaignId: any,
  reason: any
) => {
  api.put(`${url.PUT_CAMPAIGN_WITHDRAWN}`, {
    subProductId,
    campaignId,
    reason,
  });
};

export const getOtpCodeSend = (
  type: "sms",
  phoneNumber: string,
  email: string,
  isVOTP: boolean
) => api.create(url.GET_OTP_SEND, { type, phoneNumber, email, isVOTP });

export const updateOrderStatusExtendTime = (
  orderId: string,
  orderAcceptTime?: any
) =>
  api.put(url.UPDATE_ORDER_EXTEND_TIME, {
    orderId: orderId,
    time: orderAcceptTime,
  });

export const getOtpCoderReSend = (id: string, isVOTP: boolean) =>
  api.get(url.GET_OTP_RESEND, { id, isVOTP });
export const createMedia = (data: any) => api.create(url.CREATE_MEDIA, data);
export const getMedia = (
  folderid: string,
  page: any,
  count: any,
  keyword: string,
  stardate: any,
  enddate: any
) =>
  api.get(url.GET_MEDIA, {
    folderid: folderid,
    page: page,
    count: count,
    keyword,
    stardate,
    enddate,
  });
export const getMediaVideo = (page: any, count: any, keyword: string) =>
  api.get(url.GET_MEDIA_VIDEO, { page: page, count: count, keyword });
export const deleteMediaByIds = (ids: any) =>
  api.delete(url.DELETE_MEDIA_BY_IDS + ids);
export const deleteFolderId = (id: any) => api.delete(url.DELETE_FOLDER + id);
export const getBusinessBySellerId = (sellerId: any) =>
  api.get(url.GET_BUSINESS_SELLER_ID, { sellerId: sellerId });
export const createFolderApi = (data: any) =>
  api.create(url.CREATE_FOLDER, data);
export const updateFolderName = (data: any) =>
  api.put(url.UPDATE_FOLDER_NAME, data);
export const getFolder = (
  page: number,
  count: number,
  parentid: string = "defaultParentId"
) => {
  const url = `/api/v1/folder?parentid=${parentid}&page=${page}&count=${count}`;
  return api.get(url, "");
};
export const getMediaByFolderId = (page: any, count: any, id: any) =>
  api.get(url.GET_MEDIA_BY_FOLDER, { id, page: page, count: count });
export const checkMediaUrl = (data: any) => api.put(url.CHECK_MEDIA_URL, data);
export const mediaMoveToFolder = (data: any) =>
  api.put(url.MEDIA_MOVE_TO, data);
export const getMoveFolderApi = (
  page: number,
  count: number,
  parentid: string = "defaultParentId"
) => {
  const url = `/api/v1/folder?parentid=${parentid}&page=${page}&count=${count}`;
  return api.get(url, "");
};
export const getBrands = (page: any, count: any) =>
  api.get(url.GET_BRAND, { page: page, count: count });
export const getBrandsCopy = (page: any, count: any, keyword: string) =>
  api.get(url.GET_BRAND, { page: page, count: count,keyword:keyword });
export const getCategoryList = (page: any, count: any,keyword:string) =>
  api.get(url.GET_CATEGORY_LIST, {page: page, count: count,keyword: keyword });
export const getBrandByCategoryId = (page: any, count: any, categoryId: any) =>
  api.get(url.GET_BRAND, { page: page, count: count, categoryId: categoryId });
export const getSellerBrands = (
  page: any,
  count: any,
  status: string,
  keyword: string,
  relation: string
) =>
  api.get(url.GET_SELLER_BRANDS, {
    page: page,
    count: count,
    status: status,
    keyword: keyword,
    relation: relation,
  });

export const getTermAndCandition = (type: string, isBuyPassPolicy: boolean) =>
  api.get(url.GET_TERM_AND_CANDITIONS(type, isBuyPassPolicy), "");

export const getPrivacyPolicay = (type: string, isBuyPassPolicy: boolean) =>
  api.get(url.GET_TERM_AND_CANDITIONS(type, isBuyPassPolicy), "");

export const getOtpCodeVerify = (code: any, id: string) =>
  api.get(url.GET_OTP_VERIFY, { code, id });

export const getCheckUsername = (username: any) =>
  api.get(url.GET_CHECK_USERNAME + username, {});

export const createVoucher = (data: any) =>
  api.create(url.POST_VOUCHER, { ...data });

export const editVoucher = (data: any) =>
  api.put(url.UPDATE_VOUCHER, { ...data });

export const getVoucherId = (id: any) =>
  api.get(url.GET_VOUCHER_DETAIL, { id: id });

export const getMarketindDetail = (id: any) =>
  api.get(url.GET_MARKETING_DETAIL, { id: id });

export const toggleVoucher = (id: string) =>
  api.put(`${url.VOUCHERTOGGLE}?id=${id}`, {});

export const getVouchers = (
  page: number,
  count: number,
  keyword: string,
  keywordType: string,
  status: string
) =>
  api.get(url.GET_VOCHERS, {
    page: page,
    count: count,
    keyword: keyword,
    keywordType: keywordType,
    status: status,
  });

export const getMarketingRegistered = (
  page: number,
  count: number,
  campaignId: string
) =>
  api.get(url.GET_MARKETING_CAMPAIGN_REGISTERED, {
    page: page,
    count: count,
    campaignId: campaignId,
  });

export const getReviewsStatic = () => api.get(url.GET_REVIEWS_STATICS, {});

export const reviewReply = (data: any) =>
  api.create(url.REVIEW_REPLY, { ...data });

export const reviewDispute = (id: string, reason: string) =>
  api.put(`${url.REVIEW_DISPUTE}?id=${id}&reason=${reason}`, {});

export const getProductDetail = (productId: any) =>
  api.get(url.GET_PRODUCT_DETAIL, { productId: productId });
export const getProductById = (productId: any) =>
  api.get(url.GET_PRODUCT_BY_ID + productId, {});
export const deleteProductById = (productId: any) =>
  api.delete(url.DELETE_PRODUCT_BY_ID + productId);

export const createChat = (data: any) =>
  api.create(url.CREATE_CHAT, { ...data });

export const getActivitiesByOrderId = (orderId: any) =>
  api.get(url.GET_ACITIVITIES, { orderId: orderId });

export const updateOrderQuantity = (data: any) =>
  api.put(url.UPDATE_ORDERS_QUANTITY, data);

export const updateProductAvailabilty = (data: any) =>
  api.put(url.UPDATE_PRODUCT_AVAILABLITY, data);

export const updateOrderStatusTime = (
  orderId: string,
  status?: string,
  preparingTime?: any,
  sellerCancellationReason?: any,
  orderPackageImage?: any
) =>
  api.put(url.UPDATE_ORDER_STATUS_TIME, {
    orderId: orderId,
    status: status,
    preparingTime: preparingTime,
    sellerCancellationReason: sellerCancellationReason,
    orderPackageImage: orderPackageImage,
  });

export const getOrderReturnDetail = (id: any) =>
  api.get(url.GET_RETURN_ORDER_DETAIL, { id: id });
export const getReturnActivitiesByOrderId = (orderId: any) =>
  api.get(url.GET_RETURN_ACITIVITIES, { orderId: orderId });

export const getOrderStatementDetail = (statementId: any) =>
  api.get(url.GET_ORDER_STATEMENT_DETAIL, {
    statementId: statementId,
  });

  export const getOrderDetailIncome = (orderId: any) =>
  api.get(url.ORDER_DETAIL_INCOME, {
    orderId: orderId,
  });


export const getOrderIncomeStatemnt = (page : number, count: number , keyword :string,status :string,) =>
  api.get(url.ORDER_STATEMENT_INCOME_LIST , { page :page ,count:count , keyword:keyword,  status:status });

export const uploadProductInfo = (formData: FormData) =>
  api.put(url.UPLOAD_PRODUCT, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const getQSDB = (
  seller_id: string,
  start_date: string,
  end_date: string,
  types: string[]
) => {
  const queryParts = [
    `seller_id=${seller_id}`,
    `start_date=${start_date}`,
    `end_date=${end_date}`,
    ...types.map((type) => `type=${encodeURIComponent(type)}`),
  ];

  const fullUrl = `${url.GET_QSDB}?${queryParts.join("&")}`;
  return api.get(fullUrl, "");
};

